import { Injectable } from "@angular/core";
import { CallNumber } from "@ionic-native/call-number"; // Need Dependency - PageBuilder Cordova
import { Platform } from "ionic-angular";

/**
   * Crated by Hendi, 29 Jan 2020.
  */
@Injectable()
export class NativePluginServiceProvider {

	constructor(
		private callNumber: CallNumber,
		private platform: Platform
	) { }

	dialNumber(phoneNumber: string) {
		if (phoneNumber) {
			if (this.platform.is('cordova')) {
				this.callNumber.isCallSupported().then((isCall) => {
					console.log(isCall);
					this.callNumber.callNumber(phoneNumber, true).then((res) => {
						console.log('TCL: Dial number launched', phoneNumber);
					}).catch((err) => {
						console.log('TCL: Dial number error', err);
					})
				}).catch((err) => {
					console.log('TCL: Dial number error', err);
				})
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/pagebuilder/providers/plugin/native-plugin-service.ts